import _inheritsLoose from "@babel/runtime/helpers/esm/inheritsLoose";
import * as React from 'react';
import { NestingContext } from './NestingContext';
var NestingChildInner = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose(NestingChildInner, _React$Component);
  function NestingChildInner() {
    var _this;
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;
    _this.childRef = /*#__PURE__*/React.createRef();
    _this.getRefs = function () {
      return _this.props.getContextRefs(_this.childRef);
    };
    return _this;
  }
  var _proto = NestingChildInner.prototype;
  _proto.componentDidMount = function componentDidMount() {
    this.props.register(this.childRef);
  };
  _proto.componentWillUnmount = function componentWillUnmount() {
    this.props.unregister(this.childRef);
  };
  _proto.render = function render() {
    return this.props.children(this.getRefs, this.childRef);
  };
  return NestingChildInner;
}(React.Component);
export var NestingChild = function NestingChild(_ref) {
  var children = _ref.children;
  return /*#__PURE__*/React.createElement(NestingContext.Consumer, null, function (contextValue) {
    return /*#__PURE__*/React.createElement(NestingChildInner, contextValue, children);
  });
};
//# sourceMappingURL=NestingChild.js.map
